import React, { createContext, useRef } from 'react';
import CaptchaModel from './CaptchaModel';

const CaptchaContext = createContext<CaptchaModel | undefined>(undefined);

export default CaptchaContext;
